import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout';
import { Table, Button, Badge, Card, Text, Modal, TextInput, Grid, Col, Stepper, Select, Loader } from '@mantine/core';
import { Helmet } from 'react-helmet';
import { useModals } from '@mantine/modals';
import { useDispatch, useSelector } from 'react-redux';
import { getAllJobs } from '../../actions/jobActions';
import { getVehicles } from '../../actions/vehicleActions';
import find from 'lodash.find';
import get from 'lodash.get';
import moment from 'moment';
import { getCustomers } from '../../actions/customerActions';

const Jobs = ({ title }) => {

    const modals = useModals();
    const dispatch = useDispatch();

    const [opened, setOpened] = useState(false);
    const [jobOpened, setJobOpened] = useState(false);
    const [active, setActive] = useState(1);

    const { loading: allJobsLoading, jobs } = useSelector((state) => state.jobs);
    const { loading: vehiclesLoading, vehicles } = useSelector((state) => state.vehicles);
    const { loading: customersLoading } = useSelector((state) => state.customers);

    const openConfirmModal = () => {
        setOpened(false)
        modals.openConfirmModal({
            title: 'Cancel Job',
            centered: true,
            children: (
                <Text size="sm">
                    After deleting this job, you will not be able resume it again.
                </Text>
            ),
            labels: { confirm: 'Cancel Job', cancel: "Close" },
            confirmProps: { color: 'red' },
            onCancel: () => setOpened(true),
            onConfirm: () => console.log('Confirmed'),
        });
    }


    useEffect(() => {
        dispatch(getAllJobs())
        dispatch(getVehicles())
        dispatch(getCustomers())
    }, [dispatch])


    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>

            <Layout activeKey={1}>

                <Modal size='xl'
                    opened={opened}
                    onClose={() => setOpened(false)}
                    closeOnClickOutside={false}
                    centered
                    radius='md'>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='md'>Details</Text>
                    </span>
                    <Grid sx={{ margin: '0 0 30px 0' }}>
                        <Col sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} span={4}>
                            <Text>Job ID</Text>
                            <Text weight={500}>b232323332ad</Text>
                        </Col>
                        <Col sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} span={4}>
                            <Text>Vehicle</Text>
                            <Text weight={500}>CAE-3232</Text>
                        </Col>
                        <Col sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} span={4}>
                            <Text >Employee</Text>
                            <Text weight={500}>001 - John Doe</Text>
                        </Col>
                    </Grid>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 10px 10px 10px' }}>
                        <Text weight={700} size='md'>Timeline</Text>
                    </span>
                    <Stepper sx={{ margin: '20px 10px' }} active={active} onStepClick={setActive} breakpoint="sm">
                        <Stepper.Step label="Started Job" description="2022-02-01 10:35 AM">

                        </Stepper.Step>
                        <Stepper.Step label="In Progress" description="1h 30m">

                        </Stepper.Step>
                        <Stepper.Step label="End Job">

                        </Stepper.Step>
                    </Stepper>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '50px 10px 10px 10px' }}>
                        <Text weight={700} size='md'>Jobs</Text>
                        <Button radius='md' color="orange" onClick={() => setJobOpened(true)}>Create new Job</Button>
                    </span>
                    <Card withBorder sx={{ margin: '10px' }} shadow='xl' radius='md'>
                        <Grid>
                            <Col span={10}>
                                <Text weight={600}>Wash</Text>
                                <Text size='xs' color='gray'>Quick Wash</Text>
                            </Col>
                            <Col span={2}>
                                <Text>LKR 1300.00</Text>
                            </Col>
                        </Grid>
                    </Card>
                    <Card withBorder sx={{ margin: '10px' }} shadow='xl' radius='md'>
                        <Grid>
                            <Col span={10}>
                                <Text weight={600}>Wash</Text>
                                <Text size='xs' color='gray'>Quick Wash</Text>
                            </Col>
                            <Col span={2}>
                                <Text>LKR 1300.00</Text>
                            </Col>
                        </Grid>
                    </Card>
                    <Card withBorder sx={{ margin: '10px' }} shadow='xl' radius='md'>
                        <Grid>
                            <Col span={10}>
                                <Text weight={600}>Wash</Text>
                                <Text size='xs' color='gray'>Quick Wash</Text>
                            </Col>
                            <Col span={2}>
                                <Text>LKR 1300.00</Text>
                            </Col>
                        </Grid>
                    </Card>
                    <Grid sx={{ margin: '0px' }}>
                        <Col span={6}>
                            <Button color='red' radius='md' fullWidth onClick={openConfirmModal}>Cancel Job</Button>
                        </Col>
                        <Col span={6}>
                            <Button color='green' radius='md' fullWidth>End Job and Checkout</Button>
                        </Col>
                    </Grid>
                </Modal>
                <Modal size='md'
                    opened={jobOpened}
                    onClose={() => setJobOpened(false)}
                    closeOnClickOutside={false}
                    centered
                    radius='md'>
                    <Select
                        radius='md'
                        label="Job Type"
                        placeholder="Select Job Type"
                        data={[
                            { value: 'wash', label: 'Wash' },
                            { value: 'oilchange', label: 'Oil Change' },
                            { value: 'filterchange', label: 'Filter Change' },
                            { value: 'other', label: 'Other' },
                        ]}
                        required
                    />
                    <TextInput
                        radius='md'
                        sx={{ marginTop: '20px', width: '100%', fontFamily: 'Poppins' }}
                        placeholder="Tariff"
                        label="Standard Tariff"
                        required
                    />
                    <Button radius='md' sx={{ margin: '20px 0' }} fullWidth loaderPosition="right" color="orange" onClick={() => setJobOpened(false)}>
                        Create Job
                    </Button>
                </Modal>
                <Card radius='md' shadow="sm">
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Jobs</Text>
                    </span>
                    {allJobsLoading || vehiclesLoading || customersLoading ? <Loader color='orange' /> : <Table highlightOnHover>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Vehicle</th>
                                <th>Job Type</th>
                                <th>Started At</th>
                                <th>Status</th>
                                <th></th>

                            </tr>
                        </thead>
                        <tbody>
                            {jobs && jobs.map((job, key) => {
                                return <tr key={key}>
                                    <td>{job.uuid}</td>
                                    <td>{get(find(vehicles, { uuid: job.vehicleId }), 'vehicleNo', '-')}</td>
                                    <td>{job.jobType}</td>
                                    <td>{moment(job.createdAt).format('DD-MMM-YYYY HH:mm')}</td>
                                    <td><Badge color={job.completed ? 'green' : 'red'} variant="light">{job.completed ? 'Completed' : 'Ongoing'}</Badge></td>
                                    <td>
                                        <Button onClick={() => setOpened(true)} variant='light' radius='md' fullWidth color='blue'>
                                            Details
                                        </Button>
                                    </td>

                                </tr>
                            })}


                        </tbody>
                    </Table>}

                </Card>
            </Layout>
        </>
    )
}

export default Jobs
